import React from 'react';

import { FormattedMessage, MessageDescriptor } from 'react-intl-next';

export const formatText = (text: MessageDescriptor | string) => {
	return typeof text === 'string' ? text : <FormattedMessage {...text} />;
};

/**
 * Utility method to help sorting string alphabetically.
 * @param direction
 * @returns positive or negative number
 */
export const sortAlphabetically = (direction: 'asc' | 'desc') => (a: string, b: string) => {
	const aLower = a.toLowerCase();
	const bLower = b.toLowerCase();

	if (direction === 'asc') {
		return aLower.localeCompare(bLower);
	}
	return bLower.localeCompare(aLower);
};
